import { getHttp } from '@kate/plugins/http';
import { APPLICANT_PORTAL_API_PREFIX } from '@/constants';

const APPLICANT_PATH = `${APPLICANT_PORTAL_API_PREFIX}/applicant`;

// Every field is null when the applicant has no application yet.
export async function getApplicantProfile() {
  const { data } = await getHttp().get(`${APPLICANT_PATH}/profile`);
  return data;
}

// Newest first.
export async function getApplicantApplications() {
  const { data } = await getHttp().get(`${APPLICANT_PATH}/applications`);
  return data.applications;
}
